import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Link, LinkProps } from "../../../components/wpl/link/src/index";

import { ComponentStyleProps } from "./global-footer-top";

// ==================================================================
// Style Functions
// ==================================================================
const listOfLinksColumnStyle = css({
    position: "relative",
    minHeight: "1px",
    padding: "0",
    margin: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline",
    display: "block",
    color: "#091e42",
    boxSizing: "border-box",
    width: "100%"
});

const listOfLinksUlStyle = css({
    fill: "#00000000",
    marginBlockEnd: "0",
    listStyleType: "disc",
    paddingInlineStart: "20px",
    listStyle: "none"
});

const listOfLinksUlLiStyle = css({
    marginBlockEnd: "0",
    listStyleType: "none",
    marginInlineStart: "-20px",
    color: "inherit",
    fontSize: "1rem",
    lineHeight: "1.5"
});

const listOfLinksUlLiAnchorTagStyle = css({
    "color": "#42526e",
    "fontSize": "0.875rem",
    "lineHeight": "1.125",
    "textDecoration": "none",
    "verticalAlign": "baseline",

    "&:hover": {
        textDecoration: "underline",
        textShadow: "none"
    },

    "&:visited,&:focus": {
        textShadow: "none"
    }
});

const listOfLinksColumnHeaderStyle = css({
    fontSize: "14px",
    letterSpacing: "1px",
    marginBlockEnd: "20px",
    marginBlockStart: "0",
    color: "#42526e",
    lightHeight: "1.25",
    textTransform: "uppercase",
    fontWeight: "700",

    [media.below.md]: {
        marginBlockEnd: "20px"
    },

    [media.above.md]: {
        marginBlockEnd: "24px"
    }
});

const bottomViewAllLinkLiStyle = css({
    marginBlockStart: "16px",
    marginBlockEnd: "0",
    listStyleType: "none",
    marginInlineStart: "-20px",
    color: "inherit",
    fontSize: "1rem",
    lineHeight: "1.5"
});

const bottomViewAllLinkLiAnchorStyle = css({
    "color": "#0052cc",
    "fontSize": "0.875rem",
    "lineHeight": "1.125",
    "textDecoration": "none",
    "verticalAlign": "baseline",

    "&:hover,&:visited,&:focus": {
        textDecoration: "underline"
    }
});

const ComponentStyle = css(ComponentStyleProps);
// ==================================================================
// Logo Link Props
// ==================================================================
export type LinkListProps = {
    readonly headerText: string;
    readonly listOfLinks: LinkProps[];
    readonly bottomViewAllLink: LinkProps;
};

// ==================================================================
// Rendering Functions
// ==================================================================
export const LinkListContainer = ({
    headerText,
    listOfLinks,
    bottomViewAllLink
}: LinkListProps) => {
    return (
        <div css={listOfLinksColumnStyle}>
            <div css={ComponentStyle}>
                <h3 css={listOfLinksColumnHeaderStyle}>
                    {headerText.trim().toUpperCase()}
                </h3>
            </div>
            <div css={ComponentStyle}>
                <ul css={listOfLinksUlStyle}>
                    {listOfLinks.map((listOfLink) => (
                        <li
                            css={listOfLinksUlLiStyle}
                            key={listOfLink.text.trim().replace(" ", "-")}
                        >
                            <Link
                                css={listOfLinksUlLiAnchorTagStyle}
                                text={listOfLink.text}
                                href={listOfLink.href}
                                type="anchor"
                                customLinkColor="#42526e"
                                bgColor={listOfLink.bgColor}
                                onClick={listOfLink.onClick}
                                className={listOfLink.className}
                            />
                        </li>
                    ))}
                    <li
                        css={bottomViewAllLinkLiStyle}
                        key={bottomViewAllLink.text.trim().replace(" ", "-")}
                    >
                        <Link
                            css={bottomViewAllLinkLiAnchorStyle}
                            text={bottomViewAllLink.text}
                            href={bottomViewAllLink.href}
                            type="anchor"
                            customLinkColor={bottomViewAllLink.customLinkColor}
                            bgColor={bottomViewAllLink.bgColor}
                            onClick={bottomViewAllLink.onClick}
                            className={bottomViewAllLink.className}
                        />
                    </li>
                </ul>
            </div>
        </div>
    );
};
